import { Routes, Route, Navigate } from 'react-router-dom';
import { authService } from './lib/auth';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';
import DashboardLayout from './components/DashboardLayout';
import RecipeForm from './pages/RecipeForm';
import CategoryForm from './pages/CategoryForm';
import SubcategoryForm from './pages/SubcategoryForm';
import BannerForm from './pages/BannerForm';
import UnitForm from './pages/UnitForm';
import EquipmentForm from './pages/EquipmentForm';
import BannersTable from './components/BannersTable';
import IngredientCategoryForm from './pages/IngredientCategoryForm';
import IngredientForm from './pages/IngredientForm';
import SupportRequestDetailPage from './pages/SupportRequestDetailPage';
import AdminOrderDetailPage from './pages/AdminOrderDetailPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const authenticated = authService.isAuthenticated();
  const isAdmin = authService.isAdmin();
  
  if (!authenticated || !isAdmin) {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage onLogin={() => {}} />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/banners"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <BannersTable />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/recipes/new"
        element={
          <ProtectedRoute>
            <RecipeForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/recipes/:id/edit"
        element={
          <ProtectedRoute>
            <RecipeForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/categories/new"
        element={
          <ProtectedRoute>
            <CategoryForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/categories/:id/edit"
        element={
          <ProtectedRoute>
            <CategoryForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/subcategories/new"
        element={
          <ProtectedRoute>
            <SubcategoryForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/subcategories/:id/edit"
        element={
          <ProtectedRoute>
            <SubcategoryForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/banners/new"
        element={
          <ProtectedRoute>
            <BannerForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/banners/:id/edit"
        element={
          <ProtectedRoute>
            <BannerForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/units/new"
        element={
          <ProtectedRoute>
            <UnitForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/units/:id/edit"
        element={
          <ProtectedRoute>
            <UnitForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/equipment/new"
        element={
          <ProtectedRoute>
            <EquipmentForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/equipment/:id/edit"
        element={
          <ProtectedRoute>
            <EquipmentForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pantry-categories/new"
        element={
          <ProtectedRoute>
            <IngredientCategoryForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pantry-categories/:id/edit"
        element={
          <ProtectedRoute>
            <IngredientCategoryForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pantry-ingredients/new"
        element={
          <ProtectedRoute>
            <IngredientForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pantry-ingredients/:id/edit"
        element={
          <ProtectedRoute>
            <IngredientForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/support-requests/:id"
        element={
          <ProtectedRoute>
            <SupportRequestDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders/:orderId"
        element={
          <ProtectedRoute>
            <AdminOrderDetailPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;



